import React, { Fragment } from 'react';

import Button from '@material-ui/core/Button';
import { withStyles, MuiThemeProvider } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import { WithStyles } from '@material-ui/styles';

import { RezerwacjaPobyt, FakturaVatService, VatHeder, Result, VatTableRow, VatTableVat, VatNotes, VatInstalacja, PasscodeService } from '../../api';

import { Trans, WithTranslation, withTranslation, TransProps } from 'react-i18next';

import { AppState, IPageState, store, Actions, PanelState } from '../../appredux';

import { connect } from 'react-redux';

import CONFIG from '../../cfg/config';
import QRCode from 'qrcode.react';
import { downloadQRReserv, sendErrorLog, selectTheme, capitalizeText } from '../common/helpers';

import { PDFDownloadLink } from '@react-pdf/renderer';
import FakturaPdf from '../pdf/FakturaPdf';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MenuIcon from '@material-ui/icons/Menu';
import { Backdrop, IconButton, List, ListItemIcon, ListItem, ListItemText, TextField } from '@material-ui/core';

import EventIcon from '@material-ui/icons/Event';
import LocalDiningIcon from '@material-ui/icons/LocalDining';
import GroupIcon from '@material-ui/icons/Group';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import DoorSlidingIcon from '@mui/icons-material/DoorSliding';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';

import HomeIcon from '@mui/icons-material/Home';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PreviewIcon from '@mui/icons-material/Preview';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import KeyIcon from '@mui/icons-material/Key';
import theme, { kolory, ThemeOrange } from '../../themes/themes';

import { QRCode as QR} from 'react-qrcode-logo';

import './style.css'
import ZamekOtworz from './ZamekOtworz';

//GoogleAnalytics
import ReactGA from 'react-ga';

export type Content = {
    message: string,
    messageBoldPrimary?: string,
    color?: string,
    icon?: any
}

//PM 2021-08-13
//usuniecie opcjonalnosci reservationId
type DialogProps = {
    open: boolean,
    title?: string,
    titleFailure?: string,
    success?: boolean,
    paymentState?: number,
    dialogContent: Content[],
    dialogContentFailure: Content[],
    handleClose?: () => void,
    reservationId: number,
    page: IPageState,
    cancellReservation?: (id: number) => void,
    rezerwacjaPobyt: RezerwacjaPobyt,

    
}

type DialogState = {
    width: number,
    openConfirm: boolean,

    openMenu: boolean,
    openInfo: boolean,
    openPasscode: boolean,
    passcodeMode: number,
    openPdfError: boolean,

    //anchorEl: any,

    fakturaNaglowek: VatHeder,
    fakturaTable: VatTableRow[],
    fakturaTableVat: VatTableVat[],
    fakturaNotes: VatNotes[],
    fakturaSprzedawca: VatInstalacja,

    fakturaLogo: string,
}


class Notifier extends React.Component<WithTranslation & DialogProps & TransProps & WithStyles<typeof styles>, DialogState> {

    constructor(props: WithTranslation & DialogProps & TransProps & WithStyles<typeof styles>) {
        super(props, {});
        this.state = {
            width: window.innerWidth,
            openConfirm: false,
            //anchorEl: null,

            openMenu: false,
            openInfo: false,
            openPasscode: false,
            passcodeMode: 0,  // 0-obiekt  1-pokój 2-piętro 3-parking
            openPdfError: false,

            fakturaNaglowek: new VatHeder(),
            fakturaTable: [],
            fakturaTableVat: [],
            fakturaNotes: [],
            fakturaSprzedawca: new VatInstalacja(),

            fakturaLogo: ""
        };
    }

    componentDidMount() {
        this.updateWindowWidth();
        window.addEventListener('resize', this.updateWindowWidth);    
        this.checkLogo()  
    }

    checkImageExists = (imageUrl: string) => {
        return new Promise((resolve, reject) => {
          let imageData = new Image();
          imageData.onload = function () {
              resolve(true);
          };
          imageData.onerror = function () {
              reject(false);
          };
          // not really sure why you have this here, but ok
          imageData.src = imageUrl;
        });
      }

      checkLogo = async () => {
        let logo = `${CONFIG.apiURL}/hotel/image/${CONFIG.hotelID}/faktura-logo.jpg`
        //let logo = `https://vsc24.net/vscHotelBook/hotel/image/zielona-gora-FLAT/faktura-logo.jpg`

        try {
            const isImageLoaded = await this.checkImageExists(logo);
            this.setState({fakturaLogo: logo})
            //console.log(isImageLoaded);
          } catch(error) {
            console.error(error);
          }

      }
      

    componentDidUpdate(prevProps: WithTranslation & DialogProps & TransProps & WithStyles<typeof styles>) {
        if ((prevProps.page.notifierOpen !== this.props.page.notifierOpen) && this.props.handleClose)
            this.props.handleClose();

        if(this.props.open && !prevProps.open){
            this.setState({ openMenu: true });
            if(this.props.success){
                this.downloadFaktura()
            }
            ReactGA.event({
                category: 'Nawigacja',
                action: 'Zarządzaj rezerwacją'
            });
        }   

        if(this.props.page.closeDialogZarzadzaj !== prevProps.page.closeDialogZarzadzaj ){
            this.setState({ openMenu: false });
        }
    }

    handleModalClose = () => {
        if (this.props.handleClose)
            this.props.handleClose();

            this.setState({ openMenu: false, openConfirm: false, openInfo: false, openPasscode: false, openPdfError: false });
    };

    openConfirm = () => {
        //this.closeMenu()
        this.setState({ openConfirm: true });
    };

    closeConfirm = () => {
        this.setState({ openConfirm: false });
    };

    // openMenu = (event: any) => {
    //     this.setState({ anchorEl: event.currentTarget });
    // };

    openMenu = () => {
        this.setState({ openMenu: true });
    };

    closeMenu = () => {
        this.setState({ openMenu: false });
    };

    openInfo = () => {
        this.setState({ openInfo: true });
    };

    closeInfo = () => {
        this.setState({ openInfo: false });
    };

    openPasscode = (n: number) => {
        this.setState({ openPasscode: true, passcodeMode: n });
    };

    closePasscode = () => {
        this.setState({ openPasscode: false });
    };

    closePdfError = () => {
        this.setState({ openPdfError: false });
    }

    // closeMenu = () => {
    //     this.setState({ anchorEl: null });
    // };  

    FakturaKsef = async () => {
        try {
            //await store.dispatch(Actions.pageState.setPanelState(PanelState.psReservPending));
            let res = await FakturaVatService.dajVscDokNr1({
                hotelId: CONFIG.hotelID,
                vscPrzydzial: "XARC00",//this.state.fakturaNaglowek.przydzial,
                vscDokNr: this.state.fakturaNaglowek.dokNr //this.props.reservationId.toString(),

            })

            if (res && res.result[0] && res.result[0].link) {
                window.open(res.result[0].link, "_blank");
            }

            //await store.dispatch(Actions.pageState.setPanelState(PanelState.psBrowse));
        } catch (error) {
            await sendErrorLog("0", "-1", 'ksef/dajVscDokNr1')
            await store.dispatch(Actions.pageState.addFcmLogMessage('ksef/dajVscDokNr1', 2))
            //await store.dispatch(Actions.pageState.setPanelState(PanelState.psBrowse));
            alert("Nie pobrano faktury")
            console.log(error)
        }
        
    }

    FakturaPdfPobierz = async () => {
        //this.closeMenu()
        try {
            // let from = new Date(this.props.rezerwacjaPobyt.pobyt_od).getTime()
            // let now = new Date().getTime()
            // if (from > now){//nie można pobrać faktury

            if (this.props.rezerwacjaPobyt.status_id === 2){//nie można pobrać faktury
                this.setState({ openPdfError: true });
            } else {

                await store.dispatch(Actions.pageState.setPanelState(PanelState.psReservPending));

                let res = await FakturaVatService.getDokNr({ hotelId: CONFIG.hotelID, pobytId: this.props.reservationId.toString() }, {})
                let dokNr = res.result[0].dokNr

                let [res1, res2, res3, res4, res5] = await Promise.all(
                    [
                        FakturaVatService.getHeader({
                            hotelId: CONFIG.hotelID,
                            dokNr: dokNr
                        }, {}),
                        FakturaVatService.getTableRows({
                            hotelId: CONFIG.hotelID,
                            dokNr: dokNr
                        }, {}),
                        FakturaVatService.getTableVat({
                            hotelId: CONFIG.hotelID,
                            dokNr: dokNr
                        }, {}),
                        FakturaVatService.getNotes({
                            hotelId: CONFIG.hotelID,
                            dokNr: dokNr
                        }, {}),
                        FakturaVatService.getInstalacja({
                            hotelId: CONFIG.hotelID,
                        }, {})

                    ]);

                if (res.result && res1.result && res5.result) {
                    this.setState({
                        fakturaNaglowek: res1.result[0],
                        fakturaTable: res2.result === null ? [] : res2.result,
                        fakturaTableVat: res3.result === null ? [] : res3.result,
                        fakturaNotes: res4.result === null ? [] : res4.result,
                        fakturaSprzedawca: res5.result[0]
                    })
                } else {
                    throw "Nie pobrano wszystkich danych do faktury.";
                }

                //pobranie pdf-a
                await setTimeout(() => {
                    let downloadElement = document.getElementById("PDFDownload") as HTMLElement
                    let button = downloadElement.firstChild as HTMLAnchorElement
                    button.click()
                }, 100);

            }

            
            
        } catch (error) {
            await sendErrorLog("0", "-1", 'pobranie faktury VAT')
            await store.dispatch(Actions.pageState.addFcmLogMessage('pobranie faktury VAT', 2))
            alert("Nie pobrano faktury")
            console.log(error)
        }
        await store.dispatch(Actions.pageState.setPanelState(PanelState.psBrowse));




       
    }

    FakturaPdf =  () => {

        return (
            <FakturaPdf
                //tytul={this.state.fakturaNaglowek.lookUpDokTypNrWydrukOpis}//'FAKTURA VAT Nr: FA1/000/00!'
                tytul={ `${this.state.fakturaNaglowek.lookUpDokTypNrWydrukOpis} nr: ${this.state.fakturaNaglowek.dokTypNrWydruk}`}//'FAKTURA VAT Nr: FA1/000/00!'
                logo={this.state.fakturaLogo}
                rezerwacja={this.props.rezerwacjaPobyt}
                // nazwaFirmyOpis={
                // + '\n  SPRZEDAWCA:  ' + document.getElementsByTagName("title")[0].innerText.split(' ')[1]
                // + '\n  35-211 Twoje Bieszczady, 1A'
                // + '\n  Tel/ 017 788 866 66' }
                //dataOpis={"Data wystawienia  " + aDataOpis}
                koniecWydrukuOpis={`Koniec wydruku ` + this.state.fakturaNaglowek.lookUpDokTypNrWydrukOpis}
                //tablica={[]}
                //tablicaSumy={new RaportUtargJakiSpZaplatySuma()}
                //dolnyOpis={`Objaśnienia: \npok.101 Kowalski Jan \npok.102 Nowak Adam \npok.103 Wasilewski Robert!`}

                daneGorne={this.state.fakturaNaglowek}
                tableRows={this.state.fakturaTable}
                tableRowsVat={this.state.fakturaTableVat}
                fakturaNotes={this.state.fakturaNotes}
                fakturaSprzedawca={this.state.fakturaSprzedawca}
            />
        )
    }

    //PM 2021-07-07
    pobytZmien = async () => {
        //this.closeMenu()
        // vscTest

        //console.log(this.props.rezerwacjaPobyt)
        //console.log(this.props)
        if (CONFIG.grafikiRodzaj === "0" || CONFIG.grafikiRodzaj === "3") {
            //const room = this.props.page.roomsOld.find(r => r.www_rodz_pokoi_id === this.props.rezerwacjaPobyt.www_rodz_pokoi_id);
              const room = this.props.page.roomsOld.find(r => r.rodz_pokoi.trim() === this.props.rezerwacjaPobyt.rodz_pokoi.trim());
            if (room) {
                await store.dispatch(Actions.pageState.setPanelState(PanelState.psReservPending));
                await this.downloadFaktura(false)
                await store.dispatch(Actions.pageState.setCzyPobytZmieniany(true));
                await store.dispatch(Actions.pageState.setZmienianyPobyt(this.props.rezerwacjaPobyt));
                await store.dispatch(Actions.pageState.restart());
                await store.dispatch(Actions.pageState.updateBasketOld(room));
                //await store.dispatch(Actions.pageState.clearDaneNIP()); // mz 2022-06-24
                await store.dispatch(Actions.pageState.setPanelState(PanelState.psUser));
            }
        }
        else {
            const room = this.props.page.rooms.find(r => r.rodzPokoi.trim() === this.props.rezerwacjaPobyt.rodz_pokoi.trim());
            //const room = this.props.rooms.find(r => r.rodzPokoi === this.props.rezerwacjaPobyt.rodz_pokoi);
            if (room) {
                this.downloadFaktura(false)
                await store.dispatch(Actions.pageState.setCzyPobytZmieniany(true));
                await store.dispatch(Actions.pageState.setZmienianyPobyt(this.props.rezerwacjaPobyt));
                await store.dispatch(Actions.pageState.restart());
                await store.dispatch(Actions.pageState.updateBasket(room));
                //await AddItem(room.id)
                //await store.dispatch(Actions.pageState.clearDaneNIP()); // mz 2022-06-24
                await store.dispatch(Actions.pageState.setPanelState(PanelState.psUser));
            }
        }
    };

    downloadFaktura = async (przejscie: boolean = true) => {
        try {
            await store.dispatch(Actions.pageState.setPanelState(PanelState.psReservPending));
            let res = await FakturaVatService.getDokNr({ hotelId: CONFIG.hotelID, pobytId: this.props.rezerwacjaPobyt.pobyt_id.toString() }, {})
            let dokNr = res.result[0].dokNr

            if (res.result[0] && res.result[0].dokNr) {
                let res1 = await FakturaVatService.getHeader({
                    hotelId: CONFIG.hotelID,
                    dokNr: dokNr.toString()
                }, {})

                if (res1.result[0]) {
                    let nip = res1.result[0].nip//.toUpperCase().trim()
                    //nip === "." ? nip = "" : null
                    let adres = res1.result[0].adres
                    //adres === "." ? adres = "" : null
                    let nazwa = res1.result[0].kontrNazwa
                    //nazwa === "." ? nazwa = "" : null
                    this.setState({ fakturaNaglowek: res1.result[0] })
                    await store.dispatch(Actions.pageState.setDaneNIP({ nip: nip, adres: adres, kontrNazwa: nazwa }))
                    if(przejscie)
                    await store.dispatch(Actions.pageState.setPanelState(PanelState.psBrowse));
                    return
                }
            }
            if(przejscie)
            await store.dispatch(Actions.pageState.setPanelState(PanelState.psBrowse));
            await store.dispatch(Actions.pageState.clearDaneNIP());


        } catch (error) {
            await sendErrorLog("0", "-1", 'pobranie faktury VAT')
            await store.dispatch(Actions.pageState.addFcmLogMessage('pobranie faktury VAT', 2))
            //alert("Nie pobrano faktury")
            console.log(error)
            await store.dispatch(Actions.pageState.clearDaneNIP());
            await store.dispatch(Actions.pageState.setPanelState(PanelState.psBrowse));
        }
    }

    cancellReservation = () => {
        this.setState({
            openConfirm: false
        });

        this.handleModalClose()

        if (this.props.cancellReservation && this.props.reservationId)
            this.props.cancellReservation(this.props.reservationId);
    }


    

    updateWindowWidth = () => {
        this.setState({ ...this.state, width: window.innerWidth });
    }

    //PM 2021-08-13
    qrCodeValue = () => {
        let value = ''

        value = value + `${window.location.href}/${this.props.reservationId}/${this.props.rezerwacjaPobyt.gosc_telefon}\n`

        this.props.dialogContent.forEach((content, index) => {
            if (index !== 0)
                value = value + content.message + content.messageBoldPrimary + (index === this.props.dialogContent.length ? '' : '\n')
        })

        //vscTest
        //console.log(value)
        return value
    }


    tlumaczeniaParking = () => {
        const { t } = this.props;
        let index = CONFIG.lang.findIndex(x => x == this.props.page.lang)
        let ret 

        switch (index) {
            case 0:
                ret = CONFIG.menu1ParkingOpis1
                break;
            case 1:
                ret = CONFIG.menu1ParkingOpis2
                break;
            case 2:
                ret = CONFIG.menu1ParkingOpis3
                break;
            case 3:
                ret = CONFIG.menu1ParkingOpis4
                break;
            default:
                break;
        }

        if(!ret)  ret = t("parking") 
        return ret
    }
    
    tlumaczeniaObiekt = () => {
        const { t } = this.props;
        let index = CONFIG.lang.findIndex(x => x == this.props.page.lang)
        let ret 

        switch (index) {
            case 0:
                ret = CONFIG.menu1ObiektOpis1
                break;
            case 1:
                ret = CONFIG.menu1ObiektOpis2
                break;
            case 2:
                ret = CONFIG.menu1ObiektOpis3
                break;
            case 3:
                ret = CONFIG.menu1ObiektOpis4
                break;
            default:
                break;
        }

        if(!ret)  ret = t("obiekt") 
        return ret
    } 
    
    tlumaczeniaPietro= () => {
        const { t } = this.props;
        let index = CONFIG.lang.findIndex(x => x == this.props.page.lang)
        let ret 

        switch (index) {
            case 0:
                ret = CONFIG.menu1PietroOpis1
                break;
            case 1:
                ret = CONFIG.menu1PietroOpis2
                break;
            case 2:
                ret = CONFIG.menu1PietroOpis3
                break;
            case 3:
                ret = CONFIG.menu1PietroOpis4
                break;
            default:
                break;
        }

        if(!ret)  ret = t("piętro") 
        return ret
    } 
    
    tlumaczeniaPokoj = () => {
        const { t } = this.props;
        let index = CONFIG.lang.findIndex(x => x == this.props.page.lang)
        let ret 

        switch (index) {
            case 0:
                ret = CONFIG.menu1PokojOpis1
                break;
            case 1:
                ret = CONFIG.menu1PokojOpis2
                break;
            case 2:
                ret = CONFIG.menu1PokojOpis3
                break;
            case 3:
                ret = CONFIG.menu1PokojOpis4
                break;
            default:
                break;
        }

        if(!ret)  ret = t("pokój") 
        return ret
    }

    Icon = (Icon: any, color: string = 'rgb(58, 135, 173)') => { //menu
        //return <Icon color="primary" style={{ fontSize: "36px"}}/>
        return <Icon style={{ fontSize: "30px", color: color }} /> //color
    }

    Icon2 = (Icon: any, color: string = '#458B00') => { //info
        return <Icon style={{ fontSize: "25px", marginRight: "10px", float: "left", color: color }} /> 
    }

    //PM 2021-08-19
    //bez qr code na smartfonie
    render() {
        const { t, classes } = this.props;
        //const openMenu = Boolean(this.state.anchorEl);
 
        //{id: 9, 
            //title: "nasza firma", 
            //secondaryText: "pokaż dane naszej firmy", 
            //icon: CircleIcon, 
            //color: secondary, 
            //onClick: () => { store.dispatch(Actions.pageState.setDisplayState(DisplayState.naszaFirma)) } }

        let tytul = this.props.paymentState === -1 ? this.props.titleFailure : this.props.title
        let tytul2 = ""
        if (this.props.rezerwacjaPobyt && this.props.rezerwacjaPobyt.gosc_nazwisko) {
            tytul = `${this.props.rezerwacjaPobyt.pokoj_nr}`
            tytul2 = capitalizeText(this.props.rezerwacjaPobyt?.gosc_nazwisko)
        }

            let menuItemsHotelGrafiki: any[] = []

            


                if(CONFIG.menu1PobytZmien === "1" || CONFIG.menu1PobytZmien === "2")  // 0/1/2    brak/zmiana pobytu/zmiana tylko faktury
                menuItemsHotelGrafiki.push(
                    {
                        key: "2",
                        className: `${classes.menuItem} ${classes.divider} ${classes.green}`,
                        onClick: this.pobytZmien,
                        disabled: (CONFIG.menu1PobytZmien === "1" && this.props.rezerwacjaPobyt.status_id !== 2 || CONFIG.menu1PobytZmien === "1" && this.props.page.contact.payWeb === "1" && this.props.paymentState !== 2)
                        ||  (CONFIG.menu1PobytZmien === "2" && this.state.fakturaNaglowek.zamkniety === "T"),
                        //||  (CONFIG.menu1PobytZmien === "2" && this.props.rezerwacjaPobyt.status_id !== 2 && new Date(this.props.rezerwacjaPobyt.pobyt_od).getTime() < new Date().getTime()),
                        color: kolory.darkOrange,
                        title: t("Change reservation"),
                        secondaryText: t("Change reservation window"),
                        icon: GroupIcon,
                    },
                )   
                
                if(CONFIG.menu1PobytPokaz === "1")
                    menuItemsHotelGrafiki.push(
                        {
                            key: "1",
                            className: `${classes.menuItem} ${classes.divider} ${classes.green}`,
                            onClick: this.openInfo,
                            disabled: false,
                            color: kolory.green,
                            title: t("Show reservation"),
                            secondaryText: t("Show reservation window"),
                            icon: GroupIcon,
                        }
                    )

                if(CONFIG.menu1PobytAnuluj === "1")
                menuItemsHotelGrafiki.push(
                    {
                        key: "3",
                        className: `${classes.menuItem} ${classes.divider} ${classes.green}`,
                        onClick: this.openConfirm,
                        disabled: this.props.rezerwacjaPobyt.status_id !== 2 || this.props.page.contact.payWeb === "1" && this.props.paymentState !== 2,
                        color: kolory.green,
                        title: t("Cancel reservation"),
                        secondaryText: t("Cancel reservation window"),
                        icon: GroupIcon,
                    },
                )   
                
                if( CONFIG.menu1ParkingOtworz === "2")  //CONFIG.menu1ParkingOtworz === "1" ||
                menuItemsHotelGrafiki.push(
                    {
                        key: "9",
                        className: `${classes.menuItem} ${classes.divider} ${classes.blueDark}`,
                        onClick: () => this.openPasscode(3),
                        disabled: false,
                        color: kolory.blue,
                        title: t("otwórz") + " " + this.tlumaczeniaParking(),
                        //secondaryText: t("Open parking window"),
                        secondaryText: t("otwórz") + " " + this.tlumaczeniaParking(),
                        icon: DirectionsCarIcon,
                    },
                )    

                if(CONFIG.menu1ObiektOtworz === "1" || CONFIG.menu1ObiektOtworz === "2")
                menuItemsHotelGrafiki.push(
                    {
                        key: "4",
                        className: `${classes.menuItem} ${classes.divider} ${classes.blueDark}`,
                        onClick: () => this.openPasscode(0),
                        disabled: false,
                        color: kolory.blue,
                        title: t("otwórz") + " " + this.tlumaczeniaObiekt(),
                        //title: t("Open hotel"),
                        //secondaryText: t("Open hotel window"),
                        secondaryText: t("otwórz") + " " + this.tlumaczeniaObiekt(),
                        icon: HomeIcon,
                    },
                )   

                if( CONFIG.menu1PietroOtworz === "2") //CONFIG.menu1PietroOtworz=== "1" ||
                menuItemsHotelGrafiki.push(
                    {
                        key: "8",
                        className: `${classes.menuItem} ${classes.divider} ${classes.blueDark}`,
                        onClick: () => this.openPasscode(2),
                        disabled: false,
                        color: kolory.blue,
                        title: t("otwórz") + " " + this.tlumaczeniaPietro(),
                        //title: t("Open floor"),
                        //secondaryText: t("Open floor window"),
                        secondaryText: t("otwórz") + " " + this.tlumaczeniaPietro(),
                        icon: DoorSlidingIcon,
                    },
                )    

                if(CONFIG.menu1PokojOtworz === "1" || CONFIG.menu1PokojOtworz === "2")
                menuItemsHotelGrafiki.push(
                    {
                        key: "5",
                        className: `${classes.menuItem} ${classes.divider} ${classes.blueDark}`,
                        onClick: () => this.openPasscode(1),
                        disabled: false,
                        color: kolory.blue,
                        title: t("otwórz") + " " + this.tlumaczeniaPokoj(),
                        //title: t("Open room"),
                        //secondaryText: t("Open room window"),
                        secondaryText: t("otwórz") + " " + this.tlumaczeniaPokoj(),
                        icon: MeetingRoomIcon,
                    },
                )    


                if(CONFIG.menu1QrKodPobierz === "1")
                menuItemsHotelGrafiki.push(
                    {
                        key: "6",
                        className: `${classes.menuItem} ${classes.divider} ${classes.blueDark}`,
                        onClick: () => { downloadQRReserv(this.props.reservationId, this.props.rezerwacjaPobyt.pobyt_od, this.props.rezerwacjaPobyt.pobyt_do, this.props.rezerwacjaPobyt.rodz_pokoi_opis, this.props.rezerwacjaPobyt.ilosc_osob.toString());  },
                        disabled: false,
                        color: kolory.orange,
                        title: t("Download QR"),
                        secondaryText: t("Download QR window"),
                        icon: QrCode2Icon,
                    },
                )

                if(CONFIG.menu1FakturaPobierz === "1")
                menuItemsHotelGrafiki.push(
                    {
                        key: "7",
                        className: `${classes.menuItem} ${classes.divider} ${classes.blueDark}`,
                        onClick: () => this.FakturaPdfPobierz(),
                        //this.props.rezerwacjaPobyt.status_id === 1 || this.props.page.contact.payWeb === "1" && this.props.paymentState !== 2,
                        disabled: !(this.props.rezerwacjaPobyt.status_id === 3 && this.state.fakturaNaglowek.zamkniety === "T" ) ,
                        color: kolory.orange,
                        title: t("Download invoice"),
                        secondaryText: t("Download invoice window"),
                        icon: PictureAsPdfIcon,
                    },
                )

                if(CONFIG.menu1FakturaPobierz === "1")
                    menuItemsHotelGrafiki.push(
                        {
                            key: "8",
                            className: `${classes.menuItem} ${classes.divider} ${classes.blueDark}`,
                            onClick: () => this.FakturaKsef(),
                            //this.props.rezerwacjaPobyt.status_id === 1 || this.props.page.contact.payWeb === "1" && this.props.paymentState !== 2,
                            disabled: !(this.props.rezerwacjaPobyt.status_id === 3 && this.state.fakturaNaglowek.zamkniety === "T" ) ,
                            color: kolory.orange,
                            title: t("pobierz link do faktury w KSeF"),
                            secondaryText: t("pokaż fakturę w chmurze ksef"),
                            icon: PreviewIcon,
                        },
                    )
           
            
                //let err = this.state.passcode.toString() !== "0" && !this.state.passcode.toString().replace(/\s/g, "").match(/(^\d{11,12}$)|(^\d{9,9}$)/)
                //let disabled = this.state.passcode.toString() === "" || !this.state.passcode.toString().replace(/\s/g, "").match(/(^\d{11,12}$)|(^\d{9,9}$)/)
           
           
            
            // {
            //     key: "5",
            //     className: `${classes.menuItem} ${classes.green}`,
            //     onClick: () => this.closeMenu(),
            //     disabled: false,
            //     color: '#458B00',
            //     title: "wróć",
            //     secondaryText: "pokaż wróć",
            //     icon: ArrowBackIcon,
            // }
        

        if (this.props.success === true)
            return (
                <>

                    {/* <Backdrop className={classes.backdrop} open={openMenu}>
                        <Menu
                            id="long-menu"
                            anchorReference="anchorPosition"
                            anchorPosition={{ top: window.innerHeight / 2, left: window.innerWidth / 2 }}
                            anchorOrigin={{
                                vertical: 'center',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'center',
                                horizontal: 'center',
                            }}
                            keepMounted
                            elevation={15}
                            open={openMenu}
                            onClose={this.closeMenu}
                            PaperProps={{
                                style: {
                                    //maxHeight: 10 * 4.5,
                                    width: '444px', //'50ch',
                                    left: "200px",
                                    top: "200px"
                                    //paddingTop: "0"
                                },
                            }}

                            MenuListProps={{
                                style: {
                                    //maxHeight: 10 * 4.5,
                                    //width: '30ch',
                                    color: "#555",
                                    //paddingTop: "0",
                                    //paddingBottom: "0"
                                },
                            }}
                        > */}

                          
                            <Dialog
                                disableEscapeKeyDown
                                maxWidth="xs"
                                open={this.state.openMenu}
                                onClose={this.handleModalClose}
                                fullWidth
                                //BackdropProps={{
                                //    open: this.state.openConfirm ? false : true
                                //}}
                            >

                            <DialogTitle className={classes.paddingBottom0}> {/*disableTypography className={classes.title} */}
                                <Typography gutterBottom variant="h6" component="h2" color="primary"
                                //className={`${classes.headline}`}
                                >
                                    {/* <b style={{}}><Trans>Choose</Trans></b> */}
                                    <b style={{ }}>{tytul}</b> {/*textTransform: "lowercase" */}
                                    <b className={classes.titleRight}>{tytul2}</b>
                                </Typography>
                                <hr style={{ marginTop: "10px" }} />
                            </DialogTitle>
                            <DialogContent >
                                <List >
                                    {menuItemsHotelGrafiki.map((data: any, index: number) =>
                                        <ListItem
                                            key={data.key}
                                            button
                                            onClick={data.onClick}
                                            disabled={data.disabled}
                                            // className={classes.listItem}
                                            className={data.className}
                                            //style={{ paddingLeft: window.innerWidth < 600 ? "8px" : "16px", paddingRight: window.innerWidth < 600 ? "8px" : "16px", }}
                                            divider
                                        >
                                            <ListItemIcon style={{ minWidth: "52px" }}>
                                                {this.Icon(data.icon, data.color)}
                                            </ListItemIcon>

                                            <ListItemText color={data.color}
                                                primary={<Typography color="primary" style={{ color: data.color }}><b>{data.title}</b></Typography>}
                                                secondary={data.secondaryText} />
                                        </ListItem>
                                    )}


                                </List>
                                {/* <div className={classes.displayNone}>
                                    <QRCode id="qrCode" value={this.qrCodeValue()} size={256} />
                                </div> */}
                                <div className={classes.displayNone} >
                                    <div style={{ cursor: "pointer" }}>
                                        <QR id="qrCode" value={this.qrCodeValue()} size={300} logoWidth={50} logoHeight={50} removeQrCodeBehindLogo
                                            logoImage={require('../assets/icon.png').default} qrStyle="dots"
                                        />
                                    </div>
                                </div>
                                <span id="PDFDownload">
                                    <PDFDownloadLink
                                        document={this.FakturaPdf()}
                                        fileName={`${CONFIG.hotelID} - ${this.state.fakturaNaglowek.lookUpDokTypNrWydrukOpis}.pdf`}
                                        style={{ textDecoration: "none" }}>
                                        {({ blob, url, loading, error }) => null}
                                    </PDFDownloadLink>
                                </span>

                            </DialogContent >
                            <DialogActions>
                                <MuiThemeProvider theme={ThemeOrange}>
                                    <Button onClick={this.handleModalClose} variant="contained" size="small" color="primary"
                                        style={{ textTransform: "none" }}
                                    >
                                        <b><Trans>Back</Trans></b>
                                    </Button>
                                </MuiThemeProvider>   
                            </DialogActions>
                            </Dialog>




{/*                            
                        </Menu>
                    </Backdrop>   */}


                    <MuiThemeProvider theme={ selectTheme(this.props.page.windowTheme) }>
                    <Dialog
                        disableEscapeKeyDown
                        maxWidth="xs"
                        open={this.state.openInfo}
                        onClose={this.closeInfo}
                        fullWidth
                        //BackdropProps={{
                        //    open: this.state.openConfirm ? false : true
                        //}}
                    >
                        <DialogTitle disableTypography style={{ minWidth: "280px" }}>
                            <Typography variant="h6" component="h2" color={this.props.paymentState === -1 ? "error" : "primary"}>
                                {/* <b>{this.props.paymentState === -1 ? this.props.titleFailure : this.props.title}</b> */}
                                <b style={{ }}>{tytul}</b> {/*textTransform: "lowercase" */}
                                <b className={classes.titleRight}>{tytul2}</b>

                            </Typography>
                            <hr />
                        </DialogTitle>
                        <DialogContent>
                            {this.props.dialogContent.map((text: Content, index: number) => (
                                <DialogContentText key={index} color={this.props.paymentState === -1 ? "textSecondary" : "primary"} style={{ paddingLeft: text.message.includes("*") ? "12px" : "0", minHeight: "24px", fontSize: this.state.width < 600 ? "0.9rem" : "1rem" }} className={ text.color ? classes.teal :  undefined}>
                                    {text.icon ? this.Icon2(text.icon, this.props.paymentState === -1 ? "#3a87ad" : "#458B00") : null}
                                    {text.message}
                                    {text.messageBoldPrimary ?
                                         <Typography component="span" color={this.props.paymentState === -1 ? "secondary" : "primary"} ><b>{text.messageBoldPrimary}</b></Typography> : null}
                                </DialogContentText>
                            ))}
                            {/* {this.state.width > 600 ?
                                ( */}
                                    
                                {/* ) : null} */}
                        </DialogContent>

                        {/* <DialogActions> */}
                           
                            {/* {this.state.width > 600 ?
                                (
                                    <Button variant="outlined" color="primary" size="small" style={{ textTransform: "none" }}
                                        onClick={() => downloadQR(
                                            this.props.reservationId, this.props.rezerwacjaPobyt.pobyt_od, this.props.rezerwacjaPobyt.pobyt_do, this.props.rezerwacjaPobyt.rodz_pokoi_opis, this.props.rezerwacjaPobyt.ilosc_osob.toString() )}
                                    >
                                        <b>qr code</b>
                                    </Button>
                                ) : null} */}
                           
                            {/* <Button variant="outlined" color="primary" size="small" style={{ textTransform: "none" }}
                                onClick={this.openConfirm}
                                disabled={this.props.rezerwacjaPobyt.status_id === 1 || this.props.page.contact.payWeb === "1" && this.props.paymentState !== 2}
                            >
                                <b><Trans>Rezerwacje anuluj</Trans></b>
                            </Button> */}

                            {/* <Button variant="contained" color="primary" size="small" style={{ textTransform: "none" }}
                                onClick={this.pobytZmien}
                                disabled={this.props.rezerwacjaPobyt.status_id === 1 || this.props.page.contact.payWeb === "1" && this.props.paymentState !== 2}
                            >
                                <b><Trans>Rezerwacje zmien</Trans></b>
                            </Button> */}
                            
                        {/* </DialogActions> */}

                        <DialogActions>
                            
                            
                            {/* <Button onClick={() => this.FakturaPdfPobierz()} variant="outlined" color="primary" size="small" style={{ textTransform: "none" }}>
                                <b><Trans>fakturę pobierz</Trans></b>
                            </Button>        */}


                            {/* <IconButton
                                aria-label="more"
                                aria-controls="long-menu"
                                aria-haspopup="true"
                                onClick={this.openMenu}
                            >
                                <MenuIcon />
                            </IconButton> */}
                            <MuiThemeProvider theme={ThemeOrange}>
                            <Button variant="contained" color={"primary"} size="small" style={{ textTransform: "none" }}
                                onClick={this.closeInfo}>
                                <b><Trans>Back</Trans></b>
                            </Button>
                            </MuiThemeProvider>
                            {/* <Button variant="contained" color="primary" size="small" style={{ textTransform: "none" }}
                                onClick={this.openMenu}
                            >
                                <b>{"więcej"}</b>
                            </Button> */}
         

                        </DialogActions>

                        
                    </Dialog>
                    </MuiThemeProvider>       

                    <Dialog
                        disableEscapeKeyDown
                        maxWidth="xs"
                        open={this.state.openConfirm}
                        onClose={this.closeConfirm}
                        fullWidth
                    >
                        <DialogTitle disableTypography>
                            <Typography gutterBottom variant="h6" component="h2" color="primary">
                                <b><Trans>Choose</Trans></b>
                            </Typography>
                            <hr style={{ marginTop: "10px" }} />
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText className={classes.dialogContentText} >
                                <span ><Trans>Reserv cancel</Trans></span>
                            </DialogContentText>
                        </DialogContent >
                        <DialogActions >
                            <Button onClick={this.closeConfirm} variant="outlined" size="small" color="primary"
                                style={{ textTransform: "none" }}
                            >
                                <b><Trans>Back</Trans></b>
                            </Button>
                            <Button
                                onClick={this.cancellReservation}
                                variant="contained" size="small" color="primary" style={{ textTransform: "none" }}
                            //disabled={this.state.rez_id.length > 0 ? false : true}
                            >
                                <b><Trans>Next</Trans></b>
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <MuiThemeProvider theme={ selectTheme(this.props.page.windowTheme) }> 
                    <Dialog
                        disableEscapeKeyDown
                        maxWidth="xs"
                        open={this.state.openPdfError}
                        onClose={this.closePdfError}
                        fullWidth
                    >
                        <DialogTitle disableTypography>
                            <Typography gutterBottom variant="h6" component="h2" color={"error"} style={{ textTransform: "lowercase" }}>
                                <b><Trans>{"Failure"}</Trans></b>
                            </Typography>
                            <hr style={{ marginTop: "10px" }} />
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText  >
                                <Trans>Invoice download</Trans>
                            </DialogContentText>
                            
                        </DialogContent >
                        <DialogActions >
                        <MuiThemeProvider theme={ThemeOrange}>
                            <Button onClick={this.closePdfError} variant="contained" size="small" color="primary"
                                style={{ textTransform: "none" }}
                            >
                                <b><Trans>Back</Trans></b>
                            </Button>
                        </MuiThemeProvider>
                        </DialogActions>
                    </Dialog>
                    </MuiThemeProvider>       

                    <ZamekOtworz open={this.state.openPasscode} mode={this.state.passcodeMode} windowWidth={this.state.width} closePasscode={this.closePasscode} reservation={this.props.rezerwacjaPobyt}/>

                </>
            );
        else
            return (
                <MuiThemeProvider theme={ selectTheme(this.props.page.windowTheme) }>
                <Dialog
                    disableEscapeKeyDown
                    maxWidth="xs"
                    open={this.props.open}
                    onClose={this.handleModalClose}
                    fullWidth
                >
                    <DialogTitle disableTypography style={{ minWidth: "280px" }}>
                        <Typography variant="h6" component="h2" color="error">
                            <b>{this.props.titleFailure}</b>
                        </Typography>
                        <hr />
                    </DialogTitle>
                    <DialogContent>
                        {this.props.dialogContentFailure.map((text, index) => (
                            <DialogContentText key={index} /*color="primary"*/ style={{ fontSize: this.state.width < 600 ? "0.9rem" : "1rem", whiteSpace: "pre" }}>
                                {text.message}
                                {text.messageBoldPrimary ?
                                   <Typography component="span" color="secondary" ><b className={classes.pre}>{text.messageBoldPrimary}</b></Typography> : null}
                            </DialogContentText>
                        ))}
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" color="secondary" size="small"
                            onClick={this.handleModalClose}>
                            <b>OK</b>
                        </Button>
                    </DialogActions>
                </Dialog>
                </MuiThemeProvider>
            );
    }
}

const styles = (theme: Theme) => ({
    redButton: {
        marginTop: theme.spacing(3),
        color: "#ffffff",
        textShadow: "0 -1px 0 rgba(0, 0, 0, 0.25)",
        background: "linear-gradient(to bottom, #f44336, #f44336)",
        border: "1px solid #f44336",
        padding: "6px 8px 5px",
        lineHeight: "13px",
        fontSize: "11px"
    },
    confirm: {
        marginTop: theme.spacing(3),
        color: "#ffffff",
        textShadow: "0 -1px 0 rgba(0, 0, 0, 0.25)",
        background: "linear-gradient(to bottom, #69b076, #458B00)",
        padding: "6px 8px 5px",
        lineHeight: "13px",
        fontSize: "11px",
        border: "1px solid rgba(69, 139, 0, 0.5)",
        "&:hover": {
            border: "1px solid rgba(69, 139, 0, 0.5)"
        }
    },
    headline: {
        fontFamily: "\"'Open Sans'\", sans-serif",
        lineHeight: "20px",
        fontSize: "14px",
        fontWeight: 600
    },
    alert: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        background: '#ffffff',
        padding: theme.spacing(2, 4, 3),
        outline: 0
    },
    body: {
        fontSize: "12px",
        fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
        lineHeight: "20px",
        fontWeight: theme.typography.body2.fontWeight,
        color: "#555"
    },
    primary: {
        color: theme.palette.primary.main
    },
    secondary: {
        color: theme.palette.secondary.main,
        whiteSpace: "pre" as "pre"
    },
   pre: {
        whiteSpace: "pre" as "pre"
    },
    error: {
        color: theme.palette.error.main,
        whiteSpace: "pre" as "pre"
    },
    teal: {
        color: "#3a87ad"
    },
    dialogContentText: {
        //color: theme.palette.text.secondary,
        color: "#555",
        whiteSpace: "pre" as "pre",
        //fontSize: "14px"
    },
    displayNone: {
        display: 'none'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
      },
      menuItem: {
        whiteSpace: "pre" as "pre",
        paddingBottom: "8px",
        paddingTop: "8px",
        minHeight: "44px",
      },
      menuText: {
        fontSize: "0.85rem"
      },
      icon: {
        padding: "4px 4px",
        cursor: "pointer"
      },
      green: {
        //color: 'rgba(69, 139, 0, 0.5)'
        //color: 'rgba(40, 160, 0, 0.8)',
        color: theme.palette.primary.main
      },
      blueDark: {
        //color: 'rgba(0, 90, 126, 0.5)'
        //color: 'rgba(0, 90, 126, 0.8)',
        color: theme.palette.secondary.main,
      },
      brownLight: {
        //color: 'rgba(191, 136, 85, 0.5)'
        color: 'rgba(191, 136, 85, 0.8)'
      },
      divider: {
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        backgroundClip: 'padding-box',
      },
      paddingBottom0: {
        paddingBottom: 0
      },
      floatLeft: {
        float: "left" as "left"
    },
    black: {
        color: "rgb(0, 0, 0)"
    },
    input: {
        padding: "8px 14px",
        fontWeight: 'normal' as 'normal',
        textAlign: 'left' as 'left'
    },
    titleRight: {
        float: 'right' as 'right',
        whiteSpace: 'break-spaces' as 'break-spaces',
      },
      
});

const mapStateToProps = (state: AppState) => ({
    page: state.pageState
});

export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(Notifier)));